import React, { FC } from "react";
import { IconButton, ListActionButtonProps } from "sprint-common-web";

type ViewAssetButtonProps = Pick<ListActionButtonProps, "disabled" | "onClick">;

export const ViewAssetButton: FC<ViewAssetButtonProps> = (props: ViewAssetButtonProps) => (
    <IconButton
        tooltipContent="View asset"
        iconProps={{ iconName: "Redeye" }}
        disabled={props.disabled}
        onClick={props.onClick}
    />
);
